jQuery(document).ready(function ($) {
  
  // Adds Prism.js to code blocks
  if (window.Prism && typeof Prism.highlightAll === 'function') {
    Prism.highlightAll();
  }
  

  if ($(".contact-page .reposition-form, .landing-page .reposition-form").length) {
    positionContactForm();
  }

  function positionContactForm() {
    var form = $(".contact-page__form");
    var secondaryMessage = $(".contact-page__banner .hero-secondary");

    if (secondaryMessage.length && form.length) {
      var targetOffset = secondaryMessage.offset().top;
      var currentOffset = form.offset().top;
      var difference = currentOffset - targetOffset;

      form
        .css({
          transform: "translateY(-" + difference + "px)",
          "margin-bottom": "-" + difference + "px",
        })
        .addClass("transitioned");
    } else {
      var targetOffset = $("h1.hero-primary").offset().top;
      var currentOffset = form.offset().top;
      var difference = currentOffset - targetOffset;

      form
        .css({
          transform: "translateY(-" + difference + "px)",
          "margin-bottom": "-" + difference + "px",
        })
        .addClass("transitioned");
    }
  }

  if ($("#axe-api-docs").length) {
    // Add IDs to headings
    $("#axe-api-docs")
      .find("h2, h3, h4, h5")
      .each(function () {
        var text = $(this)
          .text()
          .toLowerCase()
          .replace(/[^\w ]+/g, "")
          .replace(/ +/g, "-");
        $(this).attr("id", text);
      });
  }

  if ($(".custom-select").length) {
    $(".custom-select").each(function () {
      var trigger = $(this).find("div[role=combobox]");
      var listbox = $(this).find("ul[role=listbox]");
      var input = $("#" + $(this).attr("data-input"));

      var instance = $(this);

      trigger.on("click", function (e) {
        if (trigger.attr("aria-expanded") === "false") {
          // Open listbox
          openListbox(listbox, trigger);
        } else {
          // Close listbox
          closeListbox(listbox, trigger);
        }
      });
      trigger.on("keydown", function (e) {
        switch (e.which) {
          case 40: // Down
            e.preventDefault();
            openListbox(listbox, trigger);

            break;

          case 27: // Escape
            closeListbox(listbox, trigger);

            break;

          case 13: // Enter
            if ($(this).attr("aria-expanded") === "true") {
              closeListbox(listbox, trigger);
            } else {
              openListbox(listbox, trigger);
            }

            break;

          default:
            break;
        }
      });
      listbox.find("li").on("click", function () {
        closeListbox(listbox, trigger);
        trigger.text($(this).text());
        listbox.find("li").attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");
        instance.attr("data-value", $(this).attr("data-value"));
        if (input) {
          input.val($(this).attr("data-value"));
        }
      });

      listbox.find("li").on("keydown", function (e) {
        switch (e.which) {
          case 9: // Tab on last item
            if ($(this).is(":last-child")) {
              closeListbox(listbox, trigger);
            }

            break;

          case 13: // Enter
            closeListbox(listbox, trigger);
            trigger.text($(this).text());
            $(this).attr("aria-selected", "true");
            instance.attr("data-value", $(this).attr("data-value"));
            if (input) {
              input.val($(this).attr("data-value"));
            }
            break;

          case 40: // Down
            e.preventDefault();

            // listbox.find('li').first().focus();

            if (!$(this).is(":last-child")) {
              $(this).next().focus();
            }

            break;

          case 38: // Up on first child
            e.preventDefault();
            if ($(this).is(":first-child")) {
              closeListbox(listbox, trigger);
            } else {
              $(this).prev().focus();
            }

            break;

          case 27: // Escape
            closeListbox(listbox, trigger);

            break;

          default:
            break;
        }

        if (e.which == 9 && e.shiftKey) {
          // Shift-tab
          // alert('ok');

          if ($(this).is(":first-child")) {
            e.preventDefault();
            closeListbox(listbox, trigger);
          }
        }
      });

      $("body").on("click", function (e) {
        if (!$(e.target).closest(".custom-select").length) {
          closeListbox(listbox, trigger, false);
        }
      });
    });
  }

  function openListbox(listbox, trigger) {
    listbox.attr("aria-hidden", "false");
    // listbox.find('li').attr('tabindex', '-1');
    trigger.attr("aria-expanded", "true");
    listbox.find("li").attr("tabindex", "0");
    listbox.find("li").first().focus();
  }

  function closeListbox(listbox, trigger, focus = true) {
    listbox.attr("aria-hidden", "true");
    trigger.attr("aria-expanded", "false");
    listbox.find("li").attr("tabindex", "-1");

    if (focus) {
      trigger.focus();
    }
  }

  $("#resource-filters").on("submit", function (e) {
    e.preventDefault();

    var location = "/resources";
    var cat = $("#deque_category_limiter").val();
    var type = $("#deque_type_limiter").val();

    if (cat == 0 && type != 0) {
      location = location + "/type/" + type;
    }

    if (cat != 0 && type == 0) {
      location = location + "/topic/" + cat;
    }

    if (cat != 0 && type != 0) {
      location = location + "/topic/" + cat + "/type/" + type;
    }

    window.location.href = location;
  });

  $("#blog-filters").on("submit", function (e) {
    e.preventDefault();
    var location = "/blog";
    var cat = $("#deque_category_limiter").val();
    var month = $("#deque_month_limiter").val();

    if (cat == 0 && month != 0) {
      location = location + "/" + month;
    }

    if (cat != 0 && month == 0) {
      location = location + "/category/" + cat;
    }

    if (cat != 0 && month != 0) {
      location = location + "/category/" + cat + month;
    }

    window.location.href = location;
  });

  $("body").on("submit", "form.careers-filters", function (e) {
    e.preventDefault();
    var url = e.originalEvent.srcElement.baseURI;
    var formData = $(this).serializeArray();
    console.log(formData);

    $(".careers-filters").parent().addClass("careers-loading");
    $("#loading-message").text("Careers are loading");
    $.ajax({
      url: url,
      type: "GET",
      data: formData,
      success: function (data) {
        //   alert('success');
        var html = $.parseHTML(data);
        var msg = $(data).find("#search-results-message").html();
        var results = $(data).find(".careers-list__sections").html();

        $(".careers-list__sections").html(results);
        $("#search-results-message").html(msg);
      },
      error: function (response) {
        //   alert('fail');

        console.log(response);
      },
      complete: function () {
        $(".careers-filters").parent().removeClass("careers-loading");
        $("#loading-message").text("");
      },
    });
  });
  if ($(".careers-filters.filters-applied").length) {
    $("body, html").scrollTop($(".careers-filters").parent().offset().top);
  }

  if ($("#search-results-message").length) {
    var el = $("#search-results-message");
    var msg = el.attr("data-content");

    setTimeout(function () {
      el.text(msg);
    }, 100);
  }

  $("body").on("click", ".deque-devtools-video-synopsis", function (e) {
    e.preventDefault();
    deque_open_modal("deque-devtools-video-synopsis", $(this));
  });

  $("body").on("click", '.deque-axe-sign-in-link, a[href*="deque-axe-sign-in-link"]', function (e) {
    e.preventDefault();
    deque_open_modal("deque-axe-sign-in", $(this));
    $(this).addClass("return-sign-in-focus");
  });

  $("body").on("click", ".deque-modal .modal-close, .deque-modal-overlay", function (e) {
    e.preventDefault();
    deque_close_modal();
  });

  $(".js-feature-description").hover(
    function (e) {
      $(this).parents(".pricing-table__label").addClass("has-focus");
    },
    function () {
      $(this).parents(".pricing-table__label").removeClass("has-focus");
    }
  );

  $("body").on("focus", ".js-feature-description", function (e) {
    $(this).parents(".pricing-table__label").addClass("has-focus");
  });

  $("body").on("blur", ".js-feature-description", function (e) {
    $(this).parents(".pricing-table__label").removeClass("has-focus");
  });

  /* Handle video animation */
  if ($(".video-animation").length) {
    var video = $(".video-animation video").get(0);
    $(".video-animation button").on("click", function () {
      if ($(this).hasClass("play")) {
        video.play();
        // $(this).closest('.video-animation').addClass('playing');
      } else {
        video.pause();
        // $(this).closest('.video-animation').removeClass('playing');
      }
    });
  }

  function deque_open_modal($modal_id, $trigger) {
    deque_close_modal();

    // Apply the body class for the overlay
    $("body").addClass("modal-open");

    // Show the dialog
    $(".deque-modal#" + $modal_id)
      .show()
      .addClass("shown");

    // Set page content to aria-hidden to prevent screen reading
    $("#page, #intercom-container, .intercom-lightweight-app").attr("aria-hidden", true);

    // Set all elements within page content to negative tabindex to prevent escaping focus
    $("#page *, #intercom-container *, .intercom-lightweight-app *").attr("tabindex", "-1");

    // Focus on the modal heading
    $("#" + $modal_id + " h3").focus();
  }

  function deque_close_modal() {
    // Remove the body class for the overlay
    $("body").removeClass("modal-open");

    var $open_modal = $(".deque-modal.shown");

    // Hide the dialog
    $open_modal.hide().removeClass("shown");

    // Restore screen reading for page content
    $("#page, #intercom-container, .intercom-lightweight-app").attr("aria-hidden", false);

    // Remove tabindex on elements within page content
    $("#page *, #intercom-container *, .intercom-lightweight-app *").attr("tabindex", "");

    if ($open_modal.attr("id") == "deque-axe-sign-in") {
      if ($(".return-sign-in-focus").length) {
        $(".return-sign-in-focus").focus();
      }
    }

    if ($open_modal.attr("id") == "deque-devtools-video-synopsis") {
      $(".deque-devtools-video-synopsis").first().focus();
    }
  }

  $(".deque-modal").delegate("*", "keydown", modalKeys);

  function modalKeys(event) {
    var target = event.target;
    var key = event.which;

    if (key == 27) {
      // Escape

      deque_close_modal();
    } else if (key == 9 && event.shiftKey) {
      // Shift-tab
      if ($(this).hasClass("first-focus")) {
        event.preventDefault();
        $(".modal-close").focus();
      }
    } else if (key == 9) {
      // Tab
      if ($(this).attr("id") == "modal-close") {
        event.preventDefault();
        $(".deque-modal a").first().focus();
      }
    }
  }

  $("table").each(function () {
    var colCount = 0;
    var responsiveClass = "resp-cards";

    $(this)
      .find("tbody tr:nth-child(1) td")
      .each(function () {
        if ($(this).attr("colspan")) {
          colCount += +$(this).attr("colspan");
        } else {
          colCount++;
        }
      });

    if (colCount > 5) {
      responsiveClass = "resp-scroll";

      $(this).wrap('<div class="scroll-table" tabindex="0">', "</div>");
    } else {
      responsiveClass += " count-" + colCount;

      var tableElm = $(this);

      $(this)
        .find("tr")
        .each(function () {
          row = $(this).find("td");

          for (var i = 0, len = row.length; i < len; i++) {
            c = i + 1;

            label = $(tableElm)
              .find("th:nth-child(" + c + ")")
              .text();
            $(this)
              .find("td:nth-child(" + c + ")")
              .attr("data-title", label);
          }
        });
    }

    $(this).addClass(responsiveClass);
  });

  // Open all external links in forms in new window
  $(".js-hubspot-form")
    .find("a")
    .each(function () {
      var a = new RegExp("/" + window.location.host + "/");

      if (!a.test(this.href)) {
        $(this).click(function (event) {
          event.preventDefault();
          event.stopPropagation();
          window.open(this.href, "_blank");
        });
      }
    });

  $(".deque-tooltip-marker").click(function (e) {
    e.preventDefault();
  });

  setTimeout(function () {
    if ($("#sbbfrcc").length) {
      $("#sbbfrcc")
        .find("img")
        .each(function () {
          $(this).attr("alt", "");
        });
    }
  }, 500);

  if ($(".signup-bar").length) {
    var hasGDPR = Cookies.get("CookieConsent");
    var hasClosed = Cookies.get("deque-blog-signup");
    var hasSubscribed = Cookies.get("deque-blog-subscribed");

    if (hasGDPR && !hasClosed && !hasSubscribed) {
      var docHeight = $(document).height();

      var scrollDepth = $("body").hasClass("single-post") ? 50 : 30;

      $(window).on("scroll", function () {
        var fromTop = $(document).scrollTop();

        var percentageScrolled = (fromTop / docHeight) * 100;

        if (percentageScrolled > scrollDepth) {
          $(".signup-bar").addClass("active").find(".sub--text").focus();
        }
      });
    }
  }

  $(document).on("blogSubscription", function () {
    Cookies.set("deque-blog-subscribed", 1, { expires: 365 });
  });

  $(".signup-bar .js-close-signup").click(function (e) {
    e.preventDefault();

    Cookies.set("deque-blog-signup", 1, { expires: 30 });

    $(".signup-bar.active").removeClass("active").hide();
  });

  $(".signup-bar .js-min-signup").click(function (e) {
    e.preventDefault();

    var parent = $(this).parents(".signup-bar");

    $(parent).addClass("is-minimized");
    $(parent).find(".signup-bar__content").attr("aria-hidden", "true");
    $(parent).find(".js-expand-signup").attr("aria-hidden", "false").removeAttr("tabindex").focus();
  });

  $(".signup-bar .js-expand-signup").click(function (e) {
    e.preventDefault();

    var parent = $(this).parents(".signup-bar");

    $(parent).removeClass("is-minimized");
    $(parent).find(".signup-bar__content").attr("aria-hidden", "false");
    $(parent).find(".sub--text").focus();
    $(parent).find(".js-expand-signup").attr("aria-hidden", "true").attr("tabindex", "-1");
  });

  $(".signup-bar .js-close-signup").blur(function (e) {
    setTimeout(function () {
      if (document.querySelectorAll(".signup-bar :focus").length === 0) {
        $(".signup-bar").addClass("is-minimized");
        $(".signup-bar").find(".signup-bar__content").attr("aria-hidden", "true");
        $(".signup-bar").find(".js-expand-signup").attr("aria-hidden", "false").removeAttr("tabindex");
      }
    }, 1000);
  });

  $(".resource-list__item p.item-title a").click(function (e) {
    e.preventDefault();

    var parent = $(this).parents(".resource-list__item");
    var list = $(parent).find(".resource-list__items");
    var label = $(this).data("name");

    if ($(this).hasClass("expanded")) {
      $(list).slideUp("slow");
      $(this).find("i.fa").removeClass("fa-angle-up").addClass("fa-angle-down");
      $(this)
        .attr("aria-expanded", "false")
        .removeClass("expanded")
        .attr("aria-label", "Expand " + label);
    } else {
      $(list).slideDown("slow");
      $(this).find("i.fa").removeClass("fa-angle-down").addClass("fa-angle-up");
      $(this)
        .attr("aria-expanded", "true")
        .addClass("expanded")
        .attr("aria-label", "Collapse " + label);
    }
  });

  $(".sitemap-primary a.dropdown-toggle").click(function (e) {
    e.preventDefault();

    var parent = $(this).parent();
    var target = $(this).attr("aria-controls");

    if ($(this).attr("aria-expanded") == "true") {
      $(".sitemap-primary #" + target).slideUp("slow");
      $(this).attr("aria-expanded", "false");
      $(this).find("i.fa").removeClass("fa-angle-up").addClass("fa-angle-down");
    } else {
      $(".sitemap-primary #" + target).slideDown("slow");
      $(this).attr("aria-expanded", "true");
      $(this).find("i.fa").removeClass("fa-angle-down").addClass("fa-angle-up");
    }
  });

  $("body").on("click", ".sitemap-skip", function (e) {
    e.preventDefault();
    var $listLength = $(this).next("ul").find("li").length;
    var $canfocus = $(":focusable");
    var index = $canfocus.index(document.activeElement) + $listLength + 1;
    if (index >= $canfocus.length) index = 0;
    $canfocus.eq(index).focus();
  });

  $(".sitemap-resources").delegate("ul ul li a", "keydown", siteMapSkipKeys);

  function siteMapSkipKeys(event) {
    var target = event.target;
    var key = event.which;
    var parent = $(target).parents(".resource-list__item");
    var list = parent.find(".resource-list__items");
    var label = parent.find("p a").data("name");

    if (key == 27) {
      // Escape

      list.slideUp("slow");
      parent.find("i.fa").removeClass("fa-angle-up").addClass("fa-angle-down");
      parent
        .find("p a")
        .attr("aria-expanded", "false")
        .removeClass("expanded")
        .attr("aria-label", "Expand " + label);
      parent.find("p a").focus();
    }
  }

  $.extend($.expr[":"], {
    focusable: function (el, index, selector) {
      return $(el).is("a, button, :input,[tabindex]");
    },
  });

  $(".js-feature-description").click(function (e) {
    e.preventDefault();

    if ($(this).parents(".mobile-pricing-table__feature").length) {
      parent = $(this).parents(".mobile-pricing-table__feature");
    } else {
      parent = $(this).parents(".pricing-table__label");
    }
    var label = $(this).data("feature_name");

    if ($(this).hasClass("active")) {
      $(parent).find(".pricing__feature-description").slideUp("fast");
      $(this)
        .attr("aria-expanded", "false")
        .removeClass("active")
        .attr("aria-label", "Expand " + label)
        .focus();
    } else {
      $(parent).find(".pricing__feature-description").slideDown("fast").focus();
      $(this)
        .attr("aria-expanded", "true")
        .addClass("active")
        .attr("aria-label", "Collapse " + label);
    }
  });

  if ($(".accordions").length) {
    // Remove focus from links within accordions
    $(".accordion__content a").attr("tabindex", "-1");

    $(".accordion button").click(function (e) {
      e.preventDefault();
      0;

      var parent = $(this).parents(".accordion");
      var button = $(this);

      if ($(button).attr("aria-expanded") == "true") {
        $(parent)
          .find(".accordion__content")
          .slideUp("slow", function () {
            $(button).attr("aria-expanded", "false");
            $(parent).removeClass("is-active");
          })
          .find("a")
          .attr("tabindex", "-1");
      } else {
        $(button).attr("aria-expanded", "true");
        $(parent).addClass("is-active");
        $(parent).find(".accordion__content").slideDown("slow").find("a").attr("tabindex", "0");
      }
    });
  }

  /**
   * Thin Card accordions
   */

  if ($(".thin-cards").length) {
    // Remove focusability from links within accordions
    $(".card-accordion-content-wrapper a").attr("tabindex", "-1");

    $(".thin-cards .accordion-toggle").each(function () {
      var buttonText = $(this).text();
      var collapseText = $(this).attr("data-collapse-text");
      $(this).on("click", function (e) {
        e.preventDefault();
        var contentEl = $("#" + $(this).attr("aria-controls"));
        var contentWrapper = contentEl.find(".card-accordion-content-wrapper");
        var contentHeight = contentWrapper.outerHeight();

        if ($(this).attr("aria-expanded") == "true") {
          $(contentEl).slideUp();
          $(this).text(buttonText);
          $(this).attr("aria-expanded", "false").removeClass("open");
          contentWrapper.find("a").attr("tabindex", "-1");
        } else {
          $(this).text(collapseText);
          $(contentEl).slideDown();
          contentWrapper.find("a").attr("tabindex", "0");
          $(this).attr("aria-expanded", "true").addClass("open");
        }
      });
    });

    if (window.location.hash) {
      var target = $(window.location.hash);

      if ($(target).length) {
        $(target).find(".accordion-toggle").click();
      }
    }
  }

  /**
   * UI dropdown
   */

  //make dropdowns

  function setAriaLabelledBy() {
    $(".choices").each(function () {
      var select = $(this).find("select");
      // $(this).attr('aria-labelledby', select.attr('aria-labelledby'));
      $(this).find(".choices__list").attr("role", "group");
      $(this).find(".choices__item").attr("role", "option");
      $(this).attr("aria-label", select.find("option").first().text()).attr("role", "listbox");
    });
  }

  var options = {
    searchEnabled: false,
    shouldSort: false,
    placeholderValue: 0,
    callbackOnInit: function () {
      setAriaLabelledBy();
    },
  };

  var categoryChoices = $(".category-dropdown").length > 0 ? new Choices(".category-dropdown select", options) : null;
  var typeChoices = $(".type-dropdown").length > 0 ? new Choices(".type-dropdown select", options) : null;
  var monthChoices = $(".month-dropdown").length > 0 ? new Choices(".month-dropdown select", options) : null;

  // $('#resource-filters').on( 'submit', function(e) {

  // 	e.preventDefault();

  // 	var location = '/resources';
  // 	var cat 	 = $('.category-dropdown select').val();
  // 	var type 	 = $('.type-dropdown select').val();

  // 	if( cat == 0 && type != 0 ){
  // 		location = location + '/type/' + type;
  // 	}

  // 	if( cat != 0 && type == 0 ){
  // 		location = location + '/topic/' + cat;
  // 	}

  // 	if( cat != 0 && type != 0 ){
  // 		location = location + '/topic/' + cat + '/type/' + type;
  // 	}

  // 	window.location.href = location;

  // });

  //on form submit
  // $('#blog-filters').on('submit', function(e){
  // 	e.preventDefault();

  // 	$cat = $('.category-dropdown select').val();
  // 	$date = $('.month-dropdown select').val();

  // 	// no cat or date
  // 	if( $cat == 0 && $date == 0){
  // 		location.href = "/blog/";
  // 	}

  // 	// no cat but date
  // 	if( $cat == 0 && $date != 0){
  // 		location.href = $date;
  // 	}

  // 	// has cat but no date
  // 	if( $cat != 0 && $date == 0){
  // 		location.href = "/blog/category/"+ $cat;
  // 	}

  // 	if( $cat != 0 && $date != 0 ){
  // 		$date = $date.split("/blog/")[1];
  // 		$url = "/blog/category/"+$cat+'/'+$date;
  // 		location.href = $url;

  // 	}

  // 	/*

  // 	var options = {
  // 		searchEnabled: false,
  // 		shouldSort: false,
  // 		placeholderValue: 0,
  // 		callbackOnInit: function() {
  // 			 setAriaLabelledBy();
  // 		}
  // 	}

  // 	var categoryChoices = $('.category-dropdown').length > 0 ? new Choices('.category-dropdown select', options) : null;
  // 	var typeChoices = $('.type-dropdown').length > 0 ? new Choices('.type-dropdown select', options) : null;
  // 	var monthChoices = $('.month-dropdown').length > 0 ? new Choices('.month-dropdown select', options) : null;
  // 	*/

  // });

  // $('#resource-filters').on( 'submit', function(e) {

  // 	e.preventDefault();

  // 	var location = '/resources';
  // 	var cat 	 = $('.category-dropdown select').val();
  // 	var type 	 = $('.type-dropdown select').val();

  // 	if( cat == 0 && type != 0 ){
  // 		location = location + '/type/' + type;
  // 	}

  // 	if( cat != 0 && type == 0 ){
  // 		location = location + '/topic/' + cat;
  // 	}

  // 	if( cat != 0 && type != 0 ){
  // 		location = location + '/topic/' + cat + '/type/' + type;
  // 	}

  // 	window.location.href = location;

  // });

  // //on form submit
  // $('#blog-filters').on('submit', function(e){
  // 	e.preventDefault();

  // 	$cat = $('.category-dropdown select').val();
  // 	$date = $('.month-dropdown select').val();

  // 	// no cat or date
  // 	if( $cat == 0 && $date == 0){
  // 		location.href = "/blog/";
  // 	}

  // 	// no cat but date
  // 	if( $cat == 0 && $date != 0){
  // 		location.href = $date;
  // 	}

  // 	// has cat but no date
  // 	if( $cat != 0 && $date == 0){
  // 		location.href = "/blog/category/"+ $cat;
  // 	}

  // 	if( $cat != 0 && $date != 0 ){
  // 		$date = $date.split("/blog/")[1];
  // 		$url = "/blog/category/"+$cat+'/'+$date;
  // 		location.href = $url;
  // 	}

  //  });

  /**
   * Sticky Header
   */

  if ($(".main-navigation").length) {
    // the sticky header
    var header = $(".nav-container");

    // the main nav
    var trigger = $(".main-navigation");

    var offset = 0;

    if ($("body").hasClass("admin-bar")) {
      offset += 32;
    }

    if ($("body").hasClass("no-utility-menu")) {
      offset -= 32;
    }

    // Get the offset position of the navbar plus its height to get the bottom of the menu
    var sticky = trigger.offset().top - offset;

    console.log(sticky);

    $(window).scroll(function () {
      if ($("#main-navigation").length) {
        if (window.pageYOffset >= sticky) {
          header.addClass("stuck");
          $("#masthead").css("paddingBottom", 30 + trigger.height());
          $(".site-branding .logo").attr("aria-hidden", "true").attr("tabindex", "-1");
          $(".main-navigation .logo").attr("aria-hidden", "false").removeAttr("tabindex");
        } else {
          var initPadding = $("#masthead").css("paddingBottom");
          header.removeClass("stuck");
          $("#masthead").css("paddingBottom", "30px");
          $(".site-branding .logo").attr("aria-hidden", "false").removeAttr("tabindex");
          $(".main-navigation .logo").attr("aria-hidden", "true").attr("tabindex", "-1");
        }
      }
    });
  }

  /**
   * New Menu
   *
   */

  $("#toggle-menu").click(function (e) {
    $(this).toggleClass("is-open");
  });

  $(".main-navigation [aria-expanded]").on("click", function (event) {
    if ($(window).width() <= 1024) {
      var nextMenu = $("ul#" + $(this).attr("aria-controls"));
      event.preventDefault();

      if (nextMenu.hasClass("active")) {
        closeMenu(nextMenu, $(this));
      } else {
        openMenu(nextMenu, $(this));
      }
    }
  });

  $(".main-navigation .menu-cta a").on("keydown", function (event) {
    // If we use shift-tab on the CTA when the menu is closed
    if ($(window).width() <= 1024) {
      if (event.which == 9 && event.shiftKey) {
        if ($("#toggle-menu").attr("aria-expanded") == "false") {
          $("#toggle-menu").focus();
        }
      }
    }
  });

  $("body").on("click", function (e) {
    if ($(window).width() > 1025) {
      if (!$(e.target).parents(".submenu").length) {
        var activeMenu = $(".active.sub-menu");
        closeMenu(activeMenu, $("#" + activeMenu.attr("aria-labelledby")), false);
      }
    }
  });

  // On esc key, hide any hovered menus, then remove inline styles after mouseleaving
  $(document).on("keydown", function (e) {
    if (e.which == 27) {
      closeAllSubMenus(false);
      var hoveredMenu = $("li:hover .sub-menu");
      var menuParent = hoveredMenu.parent();
      hoveredMenu.css({
        "max-height": "0vh",
        overflow: "hidden",
      });
      menuParent.on("mouseleave", function () {
        hoveredMenu.css({
          "max-height": "",
          overflow: "",
        });
      });
    }
  });

  var mobileOnly = $("#menu-primary-navigation li.mobile-only").html();

  manageMobileOnly();

  function manageMobileOnly() {
    if ($(window).width() > 1024) {
      if ($("#menu-primary-navigation li.mobile-only").length) {
        $("#menu-primary-navigation li.mobile-only").remove();
      }
    }
  }

  $("#menu-primary-navigation").delegate("li a", "keydown", mainNavKeyboard);

  $(".axe-con-navigation__menu").delegate("li a", "keydown", axeconfooterNavKeyboard);

  function axeconfooterNavKeyboard(event) {
    var target = event.target;
    var key = event.which;
    var browserSize = $(window).width();

    if (key == 37 || key == 38) {
      event.preventDefault();
      focusPrevElement($(target));
    } else if (key == 39 || key == 40) {
      event.preventDefault();
      focusNextElement($(target));
    }
  }

  function mainNavKeyboard(event) {
    var target = event.target;
    var key = event.which;
    var expandable = $(target).attr("aria-expanded");
    var nextMenu = $("ul#" + $(target).attr("aria-controls"));

    if ((key === 9 && event.shiftKey) || key == 37) {
      // Shift + Tab or Left arrow
      if (!isInCalloutList(target)) {
        if (!firstItemInMenu($(target))) {
          event.preventDefault();
          focusPrevElement($(target));
        } else if (isInMegaMenu($(target))) {
          event.preventDefault();
          focusPrevMegaMenuGroup($(target));
        } else {
          if (!expandable) {
            event.preventDefault();
            closeAllSubMenus();
            focusPrevMainElement($(target));
          }
        }

        if ($(target).parent().parent().hasClass("mobile-only") && $(target).parent().is(":first-child")) {
          $("li.mobile-only").prev().find("> a").focus();
        }
      }
    } else if (key === 9 || key === 39) {
      // Tab or Right arrow
      event.preventDefault();
      if (!lastItemInMenu($(target))) {
        focusNextElement($(target));
      } else if (isInMegaMenu($(target))) {
        if (isInCalloutList(target)) {
          return;
        } else {
          focusNextElement($(target));
        }
      } else {
        closeAllSubMenus();
        if (expandable) {
          if ($("li.mobile-only").length) {
            $(this).find("a").first().focus();
          }

          if ($(".menu-cta:visible").length) {
            $(".menu-cta a").focus();
          } else {
            $("#content *").each(function (e) {
              if (canFocus($(this))) {
                $(this).focus();
                return false;
              }
            });
          }
        } else {
          closeAllSubMenus();
          focusNextMainElement($(target));

          // Last sub-item before mobile-only items

          var parentSubmenu = $(this).parents(".sub-menu");

          if (parentSubmenu.length && parentSubmenu.parent().next().hasClass("mobile-only")) {
            $("li.mobile-only a").first().focus();
          }

          // Last mobile-only item

          if ($(this).parent().parent().hasClass("mobile-only")) {
            $("#content *").each(function (e) {
              if (canFocus($(this))) {
                $(this).focus();
                return false;
              }
            });
          }
        }
      }
    } else if (key === 13 || key === 32) {
      // Enter or Space
      if (expandable) {
        // If we're on an dropdown-toggle
        event.preventDefault();
        if (nextMenu.hasClass("active")) {
          closeMenu(nextMenu, $(target));
        } else {
          openMenu(nextMenu, $(target));
        }
      }
    } else if (key === 38) {
      // Up
      event.preventDefault();
      if (isInCalloutList(target)) {
        $(target).closest(".call-outs-menu-list").prev().find("a").last().focus();
      } else {
        if (firstItemInMenu($(target)) && !expandable) {
          if (isInMegaMenu($(target))) {
            focusPrevMegaMenuGroup($(target));
          } else {
            closeAllSubMenus();
            focusPrevMainElement($(target));
          }
        } else {
          focusPrevElement($(target));
        }
      }
    } else if (key === 40) {
      // Down
      event.preventDefault();
      if (expandable) {
        if (!nextMenu.hasClass("active")) {
          openMenu(nextMenu, $(target));
        }
      } else {
        if (isInCalloutList(target)) {
          return;
        }
        focusNextElement($(target));
      }
    } else if (key === 27) {
      // Escape
      event.preventDefault();
      closeAllSubMenus();
      if (isInMegaMenu($(target))) {
        $(target).parents(".mega-menu-parent").find("a").first().focus();
      } else {
        focusPrevMainElement($(target));
      }
    } else if (key === 36) {
      // Home
      event.preventDefault();
      if (expandable) {
        focusFirstMainElement($(target));
      } else {
        focusFirstElement($(target));
      }
    } else if (key === 35) {
      // End
      event.preventDefault();
      if (expandable) {
        focusLastMainElement($(target));
      } else {
        focusLastElement($(target));
      }
    }
  }

  function openMenu(nextMenu, toggle) {
    closeAllSubMenus();
    toggle.attr("aria-expanded", "true");
    nextMenu.attr("aria-hidden", "false");
    nextMenu.addClass("active");
    nextMenu.find("li:first-child a").first().focus();
  }

  function closeMenu(nextMenu, toggle, toggleFocus = true) {
    toggle.attr("aria-expanded", "false");
    nextMenu.removeClass("active");
    nextMenu.attr("aria-hidden", "true");
    if (toggleFocus) {
      toggle.focus();
    }
  }

  function closeAllSubMenus(toggleFocus = true) {
    $(".main-navigation .dropdown-toggle").each(function () {
      var nextMenu = $("ul#" + $(this).attr("aria-controls"));
      closeMenu(nextMenu, $(this), toggleFocus);
    });
  }

  function lastItemInMenu(target) {
    return target.parent().is(":last-child");
  }

  function isInMegaMenu(target) {
    var parent = target.parent().parent().parent();

    if (parent.hasClass("mega-menu") && $(parent).find(".menu-group-heading").length) {
      return true;
    }

    if (isInCalloutList(target)) {
      return true;
    }

    return false;

    // return target.parent().parent().parent().hasClass('mega-menu');
  }

  function isInCalloutList(target) {
    if ($(target).closest(".call-outs-menu-list").length) {
      return true;
    }

    return false;
  }

  function firstItemInMenu(target) {
    return target.parent().is(":first-child");
  }

  function lastItemSub(target) {
    return lastItemInMenu(target.parent().parent());
  }

  function focusNextElement(target) {
    if (lastItemInMenu(target) && isInMegaMenu(target)) {
      focusNextMegaMenuGroup(target);
    }

    target.parent().next().find("a").first().focus();
  }

  function focusPrevElement(target) {
    target.parent().prev().find("a").first().focus();
  }

  function focusNextMainElement(target) {
    target.parent().parent().parent().next().find("a.dropdown-toggle").first().focus();
  }

  function focusNextMegaMenuGroup(target) {
    var nextMenu = target.parent().parent().parent().next().find("ul.sub-menu").first();
    var nextCallout = target.closest(".mega-menu").next(".call-outs-menu-list").find("a");
    if (!nextMenu.length) {
      if (nextCallout.length) {
        nextCallout.focus();
      } else {
        closeAllSubMenus();
        target.parents(".mega-menu-parent").next().find("a.dropdown-toggle").first().focus();
      }
    } else {
      if (isInCalloutList(target)) {
        closeAllSubMenus();
        target.parents(".mega-menu-parent").next().find("a.dropdown-toggle").first().focus();
      } else {
        nextMenu.find("li").first().find("a").focus();
      }
    }
  }

  function focusPrevMegaMenuGroup(target) {
    var prevMenu = target.parent().parent().parent().prev().find("ul.sub-menu").first();

    if (prevMenu.length) {
      prevMenu.find("li").last().find("a").focus();
    } else {
      closeAllSubMenus();
      $(target).parents(".mega-menu-parent").find("a").first().focus();
    }
  }

  function focusPrevMainElement(target) {
    target.parent().parent().parent().find("a.dropdown-toggle").first().focus();
  }

  function focusFirstMainElement(target) {
    closeAllSubMenus();
    $(".main-navigation ul li a").first().focus();
  }

  function focusLastMainElement(target) {
    closeAllSubMenus();
    $(".main-navigation ul li:last-child a").focus();
  }

  function focusFirstElement(target) {
    $(".active.sub-menu li a").first().focus();
  }

  function focusLastElement(target) {
    $(".active.sub-menu li:last-child a").focus();
  }

  function canFocus($el) {
    if ($el.is(":hidden") || $el.is(":disabled")) {
      return false;
    }

    var tabIndex = +$el.attr("tabindex");
    tabIndex = isNaN(tabIndex) ? -1 : tabIndex;
    return $el.is(":input, a[href], area[href], iframe") || tabIndex > -1;
  }

  /**
   * Menu Accessibility
   * @return {[type]} [description]
   */

  // $('.main-navigation a').focus(function() {
  //     $(this).parents('li').addClass('focus');
  // }).blur(function() {
  //     $(this).parents('li').removeClass('focus');
  // });

  setTimeout(function () {
    $(".mm-tabstart").attr("role", "");
    $(".mm-tabend").attr("role", "");
  }, 1500);

  /*
	var top_poset = 1;
	var setsize   = $('#menu-primary-navigation > li').length;


	$('#menu-primary-navigation > li').each( function() {


		$(this).attr( 'aria-setsize', setsize );
		$(this).attr( 'aria-posinset', top_poset );
		top_poset++;

		var subnav = $(this).find('ul');

		if( $(subnav).length ) {

			var subset_size = $(subnav).find('li').length;
			var	sub_poset 	= 1;

			$(subnav).find('li').each(function() {

				$(this).attr( 'aria-setsize', subset_size );
				$(this).attr( 'aria-posinset', sub_poset );
				sub_poset++;

			});

		}

	}); */

  // $('#menu-primary-navigation').delegate( 'li a', 'keydown', keyboardHandler );
  $(".menu-cta").delegate("a", "keydown", ctaKeyboardHandler);

  // Team member specific keyboard handling
  $(".standard-section").find(".team-item").delegate("a", "keydown", teamKeyboardHandler);

  // Custom Skip To Link Fix
  $("#masthead .skip-link").click(function (e) {
    $("#main-content").attr("tabindex", "-1").focus();
  });

  /**
   * MMenu Options
   */

  /* Special support for MMENU tab navigation */

  if ($(".masonry").length) {
    $(".masonry").masonry({
      itemSelector: ".masonry-item",
    });
  }

  // Javascript transforms for product toggles
  if ($(".toggles-wrapper").length) {
    // Initially remove tabindex from .slide-panel-close
    $(".slide-panel-close").attr("tabindex", "-1");

    // Initially transform for mobile
    if ($(window).width() < 960) {
      productTogglesMobile();
    }

    // Listen for resize and transform for mobile or desktop
    $(window).on("resize", function () {
      if ($(window).width() < 960 && $(".toggles-wrapper .tabpanel ul").attr("role") == "tablist") {
        productTogglesMobile();
      } else if ($(window).width() >= 960 && $(".toggles-wrapper .tabpanel ul").attr("role") !== "tablist") {
        productTogglesDesktop();
      }
    });

    function productTogglesMobile() {
      $(".toggles-wrapper .tabpanel ul").removeAttr("role").removeAttr("aria-orientation");
      $(".product__tab").removeAttr("role");
      $(".product__tab button").removeAttr("role").removeAttr("aria-selected");
      $(".toggles-wrapper .toggles-main").insertBefore(".toggles-wrapper .toggles-controls");
    }

    function productTogglesDesktop() {
      $(".toggles-wrapper .tabpanel ul").attr("role", "tablist").attr("aria-orientation", "vertical");
      $(".product__tab").attr("role", "none");
      $(".product__tab button").attr("role", "tab");
      $(".toggles-wrapper .toggles-controls").insertBefore(".toggles-wrapper .toggles-main");
    }
  }

  $(".slide-panel-close").click(function (e) {
    e.preventDefault();

    $(this).parents(".slide-panel").removeClass("active").attr("aria-hidden", true);

    $("body").removeClass("modal-open");

    $("#content, .footer-skip-links, .site-header, .site-footer, #intercom-container, .intercom-lightweight-app").attr("aria-hidden", false);

    // Restore tabindex on elements within page content when we close the modal
    $("#content *, .footer-skip-links *, .site-header *, .site-footer *, #intercom-container *, .intercom-lightweight-app *").attr("tabindex", "");

    $(".slide-panel").attr("aria-hidden", true);
    $(".slide-panel a").attr("tabindex", "-1");

    // Remove tabindex on .slide-panel-close when we close the modal
    $(".slide-panel-close").attr("tabindex", "-1");

    $("#" + $(".slide-panel").data("return-element")).focus();

    $(".tabpanel button").removeClass("active").attr("tabindex", "0");
  });

  $(".tabs-container button[role=tab], .toggles-wrapper button.tab-wrapper").click(function (e) {
    e.preventDefault();

    var parent = $(this).parents("[role=tablist]");
    var target = $(this).attr("aria-controls");

    $(this)
      .closest(".tabs-container")
      .find("button[role=tab]")
      .each(function () {
        $(this).attr("aria-selected", "false").removeClass("active");
      });

    $(this).attr("aria-selected", "true").addClass("active");

    var isToggles = false;

    if ($(window).width() < 1081 && $(this).parents(".toggles-wrapper").length) {
      var slideContent = $("#" + target).html();

      $(".slide-panel--content").html(slideContent);

      $("#content *, .footer-skip-links *, .site-header *, .site-footer *, #intercom-container *, .intercom-lightweight-app *").attr("tabindex", "-1");
      $("#content, .footer-skip-links, .site-header, .site-footer, #intercom-container, .intercom-lightweight-app").attr("aria-hidden", true);

      $(".slide-panel").addClass("active").attr("aria-hidden", false);
      $(".slide-panel h3").focus();
      $(".slide-panel a").attr("tabindex", "0");

      $("body").addClass("modal-open");

      // Restore tabindex for .slide-panel-close when modal is opened
      $(".slide-panel-close").attr("tabindex", "");

      $(".slide-panel-close").focus();

      var returnID = $(this).attr("id");

      $(".slide-panel").data("return-element", returnID);
    } else {
      $(this)
        .closest(".tabs-container")
        .find(".content-panel")
        .each(function () {
          $(this).addClass("hide").attr("aria-hidden", "true");
        });

      $("body").removeClass("modal-open");

      var display = $(this).closest(".tablist").css("display");

      $("#" + target)
        .removeClass("hide")
        .attr("aria-hidden", "false")
        .addClass("active");
    }

    // $(parent).closest('.toggles-main').addClass('active');
    /*
			if ( $(window).width() < 1081 ) {
				$('html, body').animate({
					scrollTop: $('#' + target ).offset().top
				}, 1000);
			} */


		});


	if( $('#page iframe').length ) {

		$('#page iframe').each(function() {

			if( !$(this).parent().hasClass('responsive-embed') && $(this).attr('tabindex') != '-1' ) {
			$(this).wrap( '<div class="responsive-embed">','</div>' );
		}

		});
	}

	/**
	 * Double Tap for tablet
	 */
	if(tablet_device){
		$( '#main-navigation li.menu-item-has-children' ).doubleTapToGo();
	}

	if( $('.js-equal-height-norow').length ) {
		$('.js-equal-height-norow').matchHeight({ byRow: false });
	}

	if( $('.js-equal-height').length ) {
		$('.js-equal-height').matchHeight();
	}

	/**
	 * SVG Icons
	 */

	if( $('.svg-icon').length ) {

		$('img.svg-icon').each(function(){

			var $img 	 = jQuery(this);
			var imgID 	 = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL 	 = $img.attr('src');

			$.get(imgURL, function(data) {
				// Get the SVG tag, ignore the rest
				var $svg = jQuery(data).find('svg');

				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass+' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}

				// Replace image with new SVG
				$img.replaceWith($svg);

			}, 'xml');

		});
	}

	if( $('.m-bubbles').length ) {
		vertical_bubbles();
	}

	function vertical_bubbles() {

		var $bubbles = $('.m-bubbles');


		// Settings
		var min_bubble_count = 50, // Minimum number of bubbles
			max_bubble_count = 100, // Maximum number of bubbles
			min_bubble_size = 3, // Smallest possible bubble diameter (px)
			max_bubble_size = 12; // Maximum bubble blur amount (px)

		// Calculate a random number of bubbles based on our min/max
		var bubbleCount = min_bubble_count + Math.floor(Math.random() * (max_bubble_count + 1));

		// Create the bubbles
		for (var i = 0; i < bubbleCount; i++) {
		$bubbles.append('<div class="m-bubble-container"><div class="m-bubble"></div></div>');
		}

		// Now randomise the various bubble elements
		$bubbles.find('.m-bubble-container').each(function(){

			// Randomise the bubble positions (0 - 100%)
			var pos_rand = Math.floor(Math.random() * 101);
			var pos_rand_x = Math.floor(Math.random() * 101);

			// Randomise their size
			var size_rand = min_bubble_size + Math.floor(Math.random() * (max_bubble_size + 1));

			// Randomise the time they start rising (0-15s)
			var delay_rand = Math.floor(Math.random() * 16);

			// Randomise their speed (3-8s)
			var speed_rand = 10 + Math.floor(Math.random() * 10);

			// Random blur
			var blur_rand = Math.floor(Math.random() * 3);

			// Cache the this selector
			var $this = $(this);

			// Apply the new styles
			$this.css({
				'top' : pos_rand + '%',
				'left' : pos_rand_x + '%',

				'-webkit-animation-duration' : speed_rand + 's',
				'-moz-animation-duration' : speed_rand + 's',
				'-ms-animation-duration' : speed_rand + 's',
				'animation-duration' : speed_rand + 's',

				'-webkit-animation-delay' : delay_rand + 's',
				'-moz-animation-delay' : delay_rand + 's',
				'-ms-animation-delay' : delay_rand + 's',
				'animation-delay' : delay_rand + 's',

			});

			$this.children('.m-bubble').css({
				'width' : size_rand + 'px',
				'height' : size_rand + 'px'
			});

		});
	}

	function teamKeyboardHandler( keyVent ) {

		var target = keyVent.target;
		var which  = keyVent.which;

		// Down
		if( which == 40 ) {
			if( $(target).hasClass('images') ) {
				$(target).parent().addClass('focus');
				$(target).parent().find('.details h3 a').focus();
			}
		}

		// Up
		if( which == 38 ) {
			if( $(target).hasClass('title-link') ) {
				$(target).parents('.team-item').find('a.images').focus();
			}
		}

		if( which === 9 ) {
			$(target).parents('.team-item').removeClass('focus');
		}

	}

	function ctaKeyboardHandler( keyVent ) {

		var target 	= keyVent.target;
		var which 	= keyVent.which;

		if ((which === 9 && keyVent.shiftKey) || which === 37) { // SHIFT + TAB or Left arrow
				if( $(target).parent().is('.menu-cta') ) {
					keyVent.preventDefault();
					jQuery('#menu-primary-navigation > li:last-child > a').focus();
				}

				if ( $(target).parent().parent().is('#menu-primary-navigation') ) {

					var nextDropItem = adjacentDropdownItem(target, 'prev');

					if (nextDropItem) {
					keyVent.preventDefault();
					nextDropItem.focus();
					}

				} else if (!isTopLevel(target) && isFirstDropItem(target)) {
					keyVent.preventDefault();
					var topA = closeDropdown(target);
					setTimeout(function () {
					topA.focus();
					}, 0);
			}

			}
	}

	// determines if the item is a top-level one
	function isTopLevel(item) {
		return $(item).is('#menu-primary-navigation > li > a');
	}

	// determines if the item has a dropdown
	function hasDropdown(item) {
		return $(item.parentNode).hasClass('menu-item-has-children');
	}

	// determines if the item is the first in the dropdown
	function isFirstDropItem(item) {
		var drop = $(item).closest('.sub-menu')[0];
		var firstInDrop = $('li a', drop)[0];

		return firstInDrop === item;

	}

	// determines if the item is the last in the dropdown
	function isLastDropItem(item) {
		var drop = $(item).closest('.sub-menu')[0];
		var lastInDrop = $('li a', drop).last()[0];

		return lastInDrop === item;
	}

	// finds the adjacent top level item
	function adjacentTopLevelItem(item, dir) {
		var li = item.parentNode; // <li />
		var adjacentLi = (dir === 'next') ?
						$(li).next()[0] :
						$(li).prev()[0];
		var adjacentItem = adjacentLi && $('a', adjacentLi)[0];

		return adjacentItem;
	}

	// finds the next or prev dropdown item
	function adjacentDropdownItem(item, dir) {
		var adjacentDropItem;
		var li = item.parentNode;
		var adjacentSameCol = (dir === 'next') ?
							$(li).next()[0] :
							$(li).prev()[0];
		if (adjacentSameCol) {
		// there is one in the same col
		adjacentDropItem = $('a', adjacentSameCol)[0];
		} else {
		// lets look for one in the adjacent column
		var col = $(li).closest('.col')[0];
		var adjacentCol = (dir === 'next') ?
							$(col).next()[0] :
							$(col).prev()[0];
		if (adjacentCol) {
			// we've found the adjacent column
			var adjacentItem = (dir === 'next') ?
								$('li a', adjacentCol)[0] :
								$('li a', adjacentCol).last()[0];

			if (adjacentItem) {
			adjacentDropItem = adjacentItem;
			}
		}
		}

		return adjacentDropItem;
	}


	function openDropdown(item) {
		$(item.parentNode).addClass('active');
		var droplet = $(item).next()[0];
		// open the dropdown...
		// $(droplet).slideDown(100);
		// ...and focus the first item
		setTimeout(function () {
		$('a', droplet)[0].focus();
		}, 100);
	}

	function closeDropdown(item) {
		var droplet = $(item).closest('.sub-menu')[0];
		var topLevelItem = $(droplet).prev()[0];
		$(topLevelItem.parentNode).removeClass('active');
		// $(droplet).slideUp(100);

		return topLevelItem;
	}

	$('#colophon').on( 'blur', '.hs_email input[type="email"]', function() {

		var input = $(this);

		setTimeout( function() {
			if( jQuery(input).hasClass('error') ) {
				jQuery(input).focus();
				var parent = jQuery(input).parents('.hs-email');
				var label  = jQuery(parent).find('label');
				jQuery(parent).find('.hs-error-msgs label').attr( 'aria-describeby', jQuery(label).attr('id') );
			}
		}, 50 );

	});

	$('.newsletter-signup').on( 'submit', '.hs-form', function() {

		var input = $('.hs_email input[type="email"]');

		setTimeout( function() {
			if( jQuery(input).hasClass('error') ) {
				jQuery(input).focus();
				var parent = jQuery(input).parents('.hs-email');
				var label  = jQuery(parent).find('label');
				jQuery(parent).find('.hs-error-msgs label').attr( 'aria-describeby', jQuery(label).attr('id') );
			}
		}, 50 );

	});

	/**
		 * A11Y Fixes
		 */

	$('input#author').attr( 'autocomplete', 'given-name' );

	$('.accordion').hover(function() {
		if( $(this).hasClass('is-active') ) {
			$(this).addClass('is-focused');
		}
	}, function() {
		if( !$(this).find('.accordion__preview:focus').is(':focus') ) {
			$(this).removeClass('is-focused');
		}
	});

	$('.accordion .accordion__preview').focus(function() {
		$(this).parents('.accordion').addClass('is-focused');
	});

	$('.accordion .accordion__preview').blur(function() {
		$(this).parents('.accordion').removeClass('is-focused');
	});

	// apply role= button to youtube video player placeholder
	var $ytPlayer = $('.rll-youtube-player'),
		$ytPlayBtn;
	if ($ytPlayer.length > 0) {
		$ytPlayBtn = $ytPlayer
			.find('.play')
			.attr({
				role: "button",
				tabindex: 0
			  });
		$ytPlayBtn.attr('aria-label', 'Play Video');
	};

	/* */
	/* Promotion banner interactions */
	/* */

	var dialog = $('#promotion-banner');

        var dismissedCookie = parseInt( Cookies.get('pb_dismissed') );

        // if ( dismissedCookie == 1 ) {
        //     console.log('Dialog was previously dismissed');
        // }

        if ( dialog.length && dismissedCookie !== 1 ) {

			expandDialog( dialog );

			// Adjust height

			$('body').addClass('has-promo-banner');

      } else if (!isTopLevel(target) && isFirstDropItem(target)) {
        keyVent.preventDefault();
        var topA = closeDropdown(target);
        setTimeout(function () {
          topA.focus();
        }, 0);
      }


  // determines if the item is a top-level one
  function isTopLevel(item) {
    return $(item).is("#menu-primary-navigation > li > a");
  }

  // determines if the item has a dropdown
  function hasDropdown(item) {
    return $(item.parentNode).hasClass("menu-item-has-children");
  }

  // determines if the item is the first in the dropdown
  function isFirstDropItem(item) {
    var drop = $(item).closest(".sub-menu")[0];
    var firstInDrop = $("li a", drop)[0];

    return firstInDrop === item;
  }

  // determines if the item is the last in the dropdown
  function isLastDropItem(item) {
    var drop = $(item).closest(".sub-menu")[0];
    var lastInDrop = $("li a", drop).last()[0];

    return lastInDrop === item;
  }

  // finds the adjacent top level item
  function adjacentTopLevelItem(item, dir) {
    var li = item.parentNode; // <li />
    var adjacentLi = dir === "next" ? $(li).next()[0] : $(li).prev()[0];
    var adjacentItem = adjacentLi && $("a", adjacentLi)[0];

    return adjacentItem;
  }

  // finds the next or prev dropdown item
  function adjacentDropdownItem(item, dir) {
    var adjacentDropItem;
    var li = item.parentNode;
    var adjacentSameCol = dir === "next" ? $(li).next()[0] : $(li).prev()[0];
    if (adjacentSameCol) {
      // there is one in the same col
      adjacentDropItem = $("a", adjacentSameCol)[0];
    } else {
      // lets look for one in the adjacent column
      var col = $(li).closest(".col")[0];
      var adjacentCol = dir === "next" ? $(col).next()[0] : $(col).prev()[0];
      if (adjacentCol) {
        // we've found the adjacent column
        var adjacentItem = dir === "next" ? $("li a", adjacentCol)[0] : $("li a", adjacentCol).last()[0];

        if (adjacentItem) {
          adjacentDropItem = adjacentItem;
        }
      }
    }

    return adjacentDropItem;
  }

  function openDropdown(item) {
    $(item.parentNode).addClass("active");
    var droplet = $(item).next()[0];
    // open the dropdown...
    // $(droplet).slideDown(100);
    // ...and focus the first item
    setTimeout(function () {
      $("a", droplet)[0].focus();
    }, 100);
  }

  function closeDropdown(item) {
    var droplet = $(item).closest(".sub-menu")[0];
    var topLevelItem = $(droplet).prev()[0];
    $(topLevelItem.parentNode).removeClass("active");
    // $(droplet).slideUp(100);

    return topLevelItem;
  }

  $("#colophon").on("blur", '.hs_email input[type="email"]', function () {
    var input = $(this);

    setTimeout(function () {
      if (jQuery(input).hasClass("error")) {
        jQuery(input).focus();
        var parent = jQuery(input).parents(".hs-email");
        var label = jQuery(parent).find("label");
        jQuery(parent).find(".hs-error-msgs label").attr("aria-describeby", jQuery(label).attr("id"));
      }
    }, 50);
  });

  $(".newsletter-signup").on("submit", ".hs-form", function () {
    var input = $('.hs_email input[type="email"]');

    setTimeout(function () {
      if (jQuery(input).hasClass("error")) {
        jQuery(input).focus();
        var parent = jQuery(input).parents(".hs-email");
        var label = jQuery(parent).find("label");
        jQuery(parent).find(".hs-error-msgs label").attr("aria-describeby", jQuery(label).attr("id"));
      }
    }, 50);
  });

  /**
   * A11Y Fixes
   */

  $("input#author").attr("autocomplete", "given-name");

  $(".accordion").hover(
    function () {
      if ($(this).hasClass("is-active")) {
        $(this).addClass("is-focused");
      }
    },
    function () {
      if (!$(this).find(".accordion__preview:focus").is(":focus")) {
        $(this).removeClass("is-focused");
      }
    }
  );

  $(".accordion .accordion__preview").focus(function () {
    $(this).parents(".accordion").addClass("is-focused");
  });

  $(".accordion .accordion__preview").blur(function () {
    $(this).parents(".accordion").removeClass("is-focused");
  });

  // apply role= button to youtube video player placeholder
  var $ytPlayer = $(".rll-youtube-player"),
    $ytPlayBtn;
  if ($ytPlayer.length > 0) {
    $ytPlayBtn = $ytPlayer.find(".play").attr({
      role: "button",
      tabindex: 0,
    });
    $ytPlayBtn.attr("aria-label", "Play Video");
  }

  /* */
  /* Promotion banner interactions */
  /* */

  var dialog = $("#promotion-banner");

  var dismissedCookie = parseInt(Cookies.get("pb_dismissed"));

  // if ( dismissedCookie == 1 ) {
  //     console.log('Dialog was previously dismissed');
  // }

  if (dialog.length && dismissedCookie !== 1) {
    expandDialog(dialog);

    // Adjust height

    $("body").addClass("has-promo-banner");
  }

  $("body").on("click", "#close-promotion-banner", function () {
    $("body").removeClass("has-promo-banner");
    collapseDialog(dialog);
    dialog.detach();
    Cookies.set("pb_dismissed", 1, { expires: 40 });
  });

  function collapseDialog(dialog) {
    dialog.addClass("collapsed").attr("aria-hidden", "true");
  }

  function expandDialog(dialog) {
    dialog.removeClass("collapsed").attr("aria-hidden", "false");
  }

  // Remove tabindex from all <code> elements inside <pre> to ensure only <pre> is focusable
  $('pre code[tabindex]').removeAttr('tabindex');

  // Ensure only <pre> is focusable, <code> is not
  $('pre').attr('tabindex', '0');
  $('pre code').attr('tabindex', '-1');
});

function deque_sanitize_email() {
  jQuery(".newsletter-signup").find('input[type="email"]').removeAttr("required").attr("aria-required", "true");
}

/**
 * Displays Debug Window
 *
 * Helps find page template and checks the number of queries.
 *
 */

jQuery(document).on({
  keypress: function (event) {
    if (event.which === 68 && event.shiftKey) {
      // shift+D for debug variables
      jQuery("#debug").toggleClass("hide");
    }
  },
});

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
(function () {
  var isWebkit = navigator.userAgent.toLowerCase().indexOf("webkit") > -1,
    isOpera = navigator.userAgent.toLowerCase().indexOf("opera") > -1,
    isIe = navigator.userAgent.toLowerCase().indexOf("msie") > -1;

  if ((isWebkit || isOpera || isIe) && document.getElementById && window.addEventListener) {
    window.addEventListener(
      "hashchange",
      function () {
        var id = location.hash.substring(1),
          element;

        if (!/^[A-z0-9_-]+$/.test(id)) {
          return;
        }

        element = document.getElementById(id);

        if (element) {
          if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
          }

          element.focus();
        }
      },
      false
    );
  }
})();

/**
 * Tabs functionality
 *

var tabs = document.querySelectorAll('[role=tab]'); //get all role=tab elements as a variable
for (i = 0; i < tabs.length; i++) {
	tabs[i].addEventListener("click", showTabPanel);
} //add click event to each tab to run the showTabPanel function
*/

jQuery("[role=tablist]:not(.toggle-group ul)").keydown(function (e) {
  if (e.keyCode == 37) {
    jQuery("[aria-selected=true]").prev().click().focus();
    e.preventDefault();
  }
  if (e.keyCode == 38) {
    jQuery("[aria-selected=true]").prev().click().focus();
    e.preventDefault();
  }
  if (e.keyCode == 39) {
    jQuery("[aria-selected=true]").next().click().focus();
    e.preventDefault();
  }
  if (e.keyCode == 40) {
    jQuery("[aria-selected=true]").next().click().focus();
    e.preventDefault();
  }
});

//touch/mobile detection
if (
  navigator.userAgent.match(/Phone/i) ||
  navigator.userAgent.match(/DROID/i) ||
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/BlackBerry/) ||
  navigator.userAgent.match(/Windows Phone/i) ||
  navigator.userAgent.match(/ZuneWP7/i) ||
  navigator.userAgent.match(/IEMobile/i)
) {
  var mobile_device = true;
  var touch_device = true;
}

//touch/tablet detection
if (
  navigator.userAgent.match(/Tablet/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/Kindle/i) ||
  navigator.userAgent.match(/Playbook/i) ||
  navigator.userAgent.match(/Nexus/i) ||
  navigator.userAgent.match(/Xoom/i) ||
  navigator.userAgent.match(/SM-N900T/i) || //Samsung Note 3
  navigator.userAgent.match(/GT-N7100/i) || //Samsung Note 2
  navigator.userAgent.match(/SAMSUNG-SGH-I717/i) || //Samsung Note
  navigator.userAgent.match(/SM-T330NU/i) //Samsung Tab 4
) {
  var tablet_device = true;
  var touch_device = true;
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

jQuery(window).load(function () {
  queryParams = ["utm_medium", "utm_source", "utm_campaign"];

  if (!jQuery("body").hasClass("utm-disabled")) {
    var links = document.querySelectorAll(".free-trial-link, a.btn");

    // check if links contain domain from the domainsToDecorate array and then decorates
    for (var linkIndex = 0; linkIndex < links.length; linkIndex++) {
      links[linkIndex].href = decorateUrl(links[linkIndex].href);
    }
  }

  // decorates the URL with query params
  function decorateUrl(urlToDecorate) {
    urlToDecorate = urlToDecorate.indexOf("?") === -1 ? urlToDecorate + "?" : urlToDecorate + "&";
    var collectedQueryParams = [];
    for (var queryIndex = 0; queryIndex < queryParams.length; queryIndex++) {
      var paramName = queryParams[queryIndex];
      var paramValue = null;
      
      // Check if there's a value in the current URL first
      if (getQueryParam(paramName)) {
        paramValue = getQueryParam(paramName);
      } else {
        // Fall back to data attribute, but only if it exists and has a value
        var dataAttr = jQuery(".free-trial-link").attr("data-" + paramName);
        if (dataAttr && dataAttr !== "undefined") {
          paramValue = dataAttr;
        }
      }
      
      // Only add the parameter if we have a valid value
      if (paramValue) {
        collectedQueryParams.push(paramName + "=" + encodeURIComponent(paramValue));
      }
    }
    
    // Only add query parameters if we have any
    var url = urlToDecorate;
    if (collectedQueryParams.length > 0) {
      url = urlToDecorate + collectedQueryParams.join("&");
    } else {
      // Remove the trailing ? or & if no parameters were added
      url = urlToDecorate.replace(/[?&]$/, "");
    }

    // Detect and fix urls with hashes
    if (urlToDecorate.includes("#")) {
      var urlHash = urlToDecorate.substring(urlToDecorate.indexOf("#"));
      var urlHash = urlHash.slice(0, -1);
      url = url.replace(urlHash, "") + urlHash;
    }

    return url;
  }

  function getQueryParam(name) {
    if ((name = new RegExp("[?&]" + encodeURIComponent(name) + "=([^&]*)").exec(window.location.search))) return decodeURIComponent(name[1]);
  }
});